import Journey from "models/journey/journey";
import PaxSession, { PaxSessionFromApi } from "./pax-session";
import { PaxCheckMultipaxSession, PaxCheckPaxSession } from "api";
import ArrivalPoint from "models/journey/arrival-point";
import { parse, isValid } from "date-fns";
import DeparturePoint from "models/journey/departure-point";

export type MultiPaxSessionId = string;

class MultiPaxSession {
  sessionId: MultiPaxSessionId;
  paxSessions: PaxSession[];
  journey: Journey;

  constructor(
    sessionId: MultiPaxSessionId,
    paxSessions: PaxSession[],
    journey: Journey
  ) {
    this.sessionId = sessionId;
    this.paxSessions = paxSessions;
    this.journey = journey;
  }
}

export function MultiPaxSessionFromApi(
  res: PaxCheckMultipaxSession,
  chosenPaxSessionIds: string[] | null
): MultiPaxSession {
  const paxSessions: PaxSession[] = res.paxs
    .map((paxSession: PaxCheckPaxSession) => PaxSessionFromApi(paxSession))
    .filter(
      (pax) =>
        !chosenPaxSessionIds?.length ||
        chosenPaxSessionIds.includes(pax.paxSessionId)
    );

  const arrival: ArrivalPoint = {
    airport: {
      name: res.journey.arrival.airport.airportName,
      code: res.journey.arrival.airport.airportCode,
      city: res.journey.arrival.airport.cityName,
    },

    arrivalLocalDatetime: parse(
      res.journey.arrival.arrivalDatetime,
      "yyyy-MM-dd HH:mm",
      new Date()
    ),
    country: res.journey.arrival.countryCode,
  };

  const transit = res.journey.transit
    ? res.journey.transit.flatMap((stop) => {
        if (!stop.airport) return [];
        const arrivalLocalDatetime = parse(
          stop.arrivalDatetime,
          "yyyy-MM-dd HH:mm",
          new Date()
        );
        const departureLocalDatetime = parse(
          stop.departureDatetime,
          "yyyy-MM-dd HH:mm",
          new Date()
        );
        if (!isValid(arrivalLocalDatetime) || !isValid(departureLocalDatetime)) {
          return [];
        }
        return [{
          airportName: stop.airport.airportName,
          airportCode: stop.airport.airportCode,
          arrivalLocalDatetime,
          departureLocalDatetime,
        }];
      })
    : [];

  const departure: DeparturePoint = {
    airport: {
      name: res.journey.departure.airport.airportName,
      code: res.journey.departure.airport.airportCode,
      city: res.journey.departure.airport.cityName,
    },
    departureLocalDatetime: parse(
      res.journey.departure.departureDatetime,
      "yyyy-MM-dd HH:mm",
      new Date()
    ),
    country: res.journey.departure.countryCode,
  };

  const journey: Journey = {
    arrival: arrival,
    transit: transit,
    departure: departure,
    flightNumbers: res.journey.flightNumbers,
  };

  return {
    sessionId: res.id,
    paxSessions,
    journey,
  };
}

export default MultiPaxSession;
